// export const endPoint = "http://localhost:5004/";
// export const endPointServer = "http://localhost:5004";
export const endPoint = "https://be.tetapsolartuff.com/";
export const endPointServer = "https://be.tetapsolartuff.com";
export const stars = [
  { top: "20%", left: "30%", size: 5, delay: "0s" },
  { top: "40%", left: "60%", size: 4, delay: "1s" },
  { top: "70%", left: "20%", size: 6, delay: "2s" },
  { top: "80%", left: "80%", size: 3, delay: "0.5s" },
  { top: "10%", left: "50%", size: 4, delay: "1.2s" },
  { top: "25%", left: "75%", size: 3, delay: "0.8s" },
  { top: "60%", left: "40%", size: 5, delay: "1.5s" },
  { top: "85%", left: "15%", size: 4, delay: "2.5s" },
  { top: "5%", left: "20%", size: 6, delay: "1s" },
  { top: "90%", left: "50%", size: 3, delay: "1.8s" },
  { top: "15%", left: "80%", size: 4, delay: "0.3s" },
  { top: "35%", left: "10%", size: 5, delay: "2.2s" },
  { top: "55%", left: "70%", size: 3, delay: "1.7s" },
  { top: "75%", left: "30%", size: 6, delay: "0.9s" },
  { top: "45%", left: "90%", size: 4, delay: "1.4s" },
  { top: "65%", left: "60%", size: 5, delay: "0.6s" },
  { top: "20%", left: "10%", size: 3, delay: "1.1s" },
  { top: "50%", left: "80%", size: 4, delay: "2.4s" },
  { top: "80%", left: "40%", size: 5, delay: "0.7s" },
  { top: "30%", left: "90%", size: 6, delay: "1.9s" },
];
